import { MessageCircle } from "lucide-react";

const PHONE = "917004810637"; // +91 70048 10637
const MESSAGE = "Hello Tikratoli, I would like to enquire about a stay / event.";

export default function WhatsAppButton() {
  const href = `https://wa.me/${PHONE}?text=${encodeURIComponent(MESSAGE)}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fab"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-40 group inline-flex items-center gap-3 pl-4 pr-5 py-3 bg-[#25D366] hover:bg-[#1EBE57] transition-all duration-300 shadow-lg shadow-black/40 rounded-full"
    >
      <MessageCircle size={20} className="text-white" strokeWidth={2.2} />
      <span className="font-mono-label text-white text-xs tracking-widest">
        WhatsApp
      </span>
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30 pointer-events-none" />
    </a>
  );
}
